import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type AxiosPromise } from "axios";
import { useApi } from "utilities/hookutils";

export const useLoadFilterPresets = <TInstruction>(
  cacheKey: string,
  listApi: () => AxiosPromise<server.dto.ApiResponseWrapper<server.dto.FilterPreset<TInstruction>[]>>
) => {
  return useApi(listApi, [cacheKey]);
};

export const useAddFilterPreset = <TInstruction>(
  cacheKey: string,
  mutateApi: (instruction: server.dto.CreateFilterPresetInstruction<TInstruction>) => AxiosPromise<any>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (instruction: server.dto.CreateFilterPresetInstruction<TInstruction>) => {
      const res = await mutateApi(instruction);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [cacheKey] });
    }
  });
};

export const useRemoveFilterPreset = (cacheKey: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (filterPresetId: number) => {
      await window.CoreApi.FilterPreset.DeleteFilterPreset(filterPresetId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [cacheKey] });
    }
  });
};